import React from 'react';

const ArBox = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 11.8332V6.16652C16.2497 5.91809 16.1803 5.67409 16.0487 5.45901C15.917 5.24392 15.7278 5.06532 15.5 4.9411L10.25 2.10777C10.022 1.98343 9.7633 1.91797 9.5 1.91797C9.23669 1.91797 8.97803 1.98343 8.75 2.10777L3.5 4.9411C3.2722 5.06532 3.08299 5.24392 2.95135 5.45901C2.81971 5.67409 2.75027 5.91809 2.75 6.16652V11.8332C2.75027 12.0816 2.81971 12.3256 2.95135 12.5407C3.08299 12.7558 3.2722 12.9344 3.5 13.0586L8.75 15.8919C8.97803 16.0163 9.23669 16.0817 9.5 16.0817C9.7633 16.0817 10.022 16.0163 10.25 15.8919L15.5 13.0586C15.7278 12.9344 15.917 12.7558 16.0487 12.5407C16.1803 12.3256 16.2497 12.0816 16.25 11.8332Z"
        stroke="#004225"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.95215 5.43018L9.49965 9.00726L16.0471 5.43018"
        stroke="#004225"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 16.14V9"
        stroke="#004225"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArBox;
